module.exports = __webpack_public_path__ + "src/img/defaultMedia.a66febde.png";